import { validate } from '../validate.js';
import { planEmbeddings } from './plan.js';
import { COMPILED_SPEC_VERSION, sha256, } from './artifact.js';
/**
 * Build a compiled artifact without touching the filesystem. The browser
 * editor uses this; Node callers should prefer `build(folder, ...)` which
 * reads and writes on disk. `embedding-source` file roles are skipped
 * because the browser cannot read them.
 */
export async function buildInMemory(opts) {
    const { doc, source, embedder, prior, skipProbe, onProgress } = opts;
    const validation = validate(doc);
    if (!validation.valid) {
        const first = validation.errors[0];
        throw new Error(`buildInMemory: cannot compile — ${validation.errors.length} schema error(s). ` +
            `First: ${first?.path ?? '/'} ${first?.message ?? ''}`);
    }
    if (!skipProbe)
        await embedder.probe();
    const targets = planEmbeddings(doc); // no folder → skip embedding-source
    const priorTexts = prior && prior.model === embedder.model ? priorTextIndex(prior) : null;
    const embeddings = {};
    let cacheHits = 0;
    let cacheMisses = 0;
    for (let i = 0; i < targets.length; i++) {
        const target = targets[i];
        const cached = priorTexts && tryCache(priorTexts, prior, target.path, target.text);
        if (cached) {
            embeddings[target.path] = cached;
            cacheHits++;
        }
        else {
            embeddings[target.path] = await embedder.embed(target.text);
            cacheMisses++;
        }
        onProgress?.(i + 1, targets.length, target.path);
    }
    return {
        artifact: {
            spec_version: COMPILED_SPEC_VERSION,
            source_hash: await sha256(source),
            model: embedder.model,
            remedy: doc,
            embeddings,
        },
        cacheHits,
        cacheMisses,
    };
}
function priorTextIndex(prior) {
    const targets = planEmbeddings(prior.remedy);
    const out = new Map();
    for (const t of targets)
        out.set(t.path, t.text);
    return out;
}
function tryCache(priorTexts, prior, path, text) {
    if (priorTexts.get(path) !== text)
        return undefined;
    const vec = prior.embeddings[path];
    return Array.isArray(vec) ? vec : undefined;
}
//# sourceMappingURL=build-browser.js.map